import { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { format } from 'date-fns';

import styles from './PrintForUser.module.scss';

const cx = classNames.bind(styles);

interface PrintForUserProps {
  userFullName: string | undefined;
}

const DATE_FORMAT = 'dd MMM yyyy';

const getCurrentDate = () => format(new Date(), DATE_FORMAT);

const PrintForUser = ({ userFullName }: PrintForUserProps): ReactElement | null => {
  if (!userFullName) {
    return null;
  }

  return (
    <div className={cx('body')}>
      <span>
        Printed for {userFullName.toUpperCase()} on {getCurrentDate()}
      </span>
    </div>
  );
};

export default PrintForUser;
